import React, { Fragment, useState } from "react"
import { FaChevronDown, FaChevronUp } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import { Collapse } from "react-collapse"
import clsx from "clsx"

import classes from "./FoodCategoryDropdownItem.module.scss"

const FoodCategoryDropdownItem = props => {
  const { onSelect, category } = props

  const i18n = useTranslation()[1]

  const [collapse, setCollapse] = useState(true)

  const handleSelect = (e) => {
    e.stopPropagation()

    onSelect(category)
  }

  const haveChildren =
    category.children.length > 0

  const dir = i18n.dir(i18n.language)

  const isLtr = dir === "ltr"

  return (
    <Fragment>
      <div className={classes["category"]}>
        {
          haveChildren &&
          <button
            onClick={() => setCollapse(prev => !prev)}
            className={clsx(classes["button"], isLtr && classes["button-ltr"])}
          >
            {collapse ? <FaChevronUp /> : <FaChevronDown />}
          </button>
        }
        <span
          onClick={handleSelect}
          className={classes["text"]}
        >
          {category.name}
        </span>
      </div>

      {
        haveChildren &&
        <Collapse isOpened={collapse}>
          <div
            className={clsx(
              classes["children"],
              isLtr && classes["children-ltr"]
            )}
          >
            {category.children.map(category =>
              <FoodCategoryDropdownItem
                key={category._id}
                category={category}
                onSelect={onSelect}
              />
            )}
          </div>
        </Collapse>
      }
    </Fragment>
  )
}

export default FoodCategoryDropdownItem